import { useCallback } from 'react';
import { useDeleteConsignmentLineMutation } from '../api/consignmentsApi';
import type { ConsignmentLineUpdateParams } from './types';

export interface UseDeleteConsignmentLineOptions {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
}

export const useDeleteConsignmentLine = (options?: UseDeleteConsignmentLineOptions) => {
  const [deleteConsignmentLine, { isLoading, isError, error }] = useDeleteConsignmentLineMutation();

  const deleteLine = useCallback(
    async (params: ConsignmentLineUpdateParams) => {
      try {
        await deleteConsignmentLine(params).unwrap();
        options?.onSuccess?.();
      } catch (err) {
        console.error('Failed to delete consignment line:', err);
        options?.onError?.(err);
      }
    },
    [deleteConsignmentLine, options]
  );

  return {
    deleteConsignmentLine: deleteLine,
    isLoading,
    isError,
    error
  };
};
